import React, { useContext, useEffect, useMemo } from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { EventContext } from "@gp/components";
import { useRootAppStore } from "@hooks";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import { rootStore } from "@state/module-root";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

import { EmptyContent, EventContentSkeleton } from "..";
import {
	Modals,
	MyBetsAutosellConfirmation,
} from "@features/my-bets/desktop/additional-offer";
import { MyBetsBetsList } from "./MyBetsBetsList";

export const MyBetsBody = observer(function MyBetsBody() {
	const event = useContext(EventContext);
	const { myBetsViewStore } = useRootAppStore();
	const { t } = useTranslation("mybets");
	const myBetsStore = useMemo(() => {
		return new MyBetsStore(rootStore, "MyBetsPage");
	}, []);

	useEffect(() => {
		myBetsViewStore.fetchAdditionalOffers(event.id);

		return () => {
			myBetsViewStore.onEventBetsDispose(event.id);
		};
	}, []);

	const content = (function () {
		if (
			myBetsViewStore.loadingBetsForEventIds.has(event.id) &&
			myBetsViewStore.isEventBetsLoading
		) {
			return <EventContentSkeleton />;
		}

		const eventBetsState = myBetsViewStore.betsPerEvent.find(
			(item) => item.eventId === event.id
		);

		if (
			!eventBetsState ||
			myBetsViewStore.loadingBetsForEventIds.has(event.id)
		) {
			return null;
		}

		if (eventBetsState.bets.length === 0) {
			return <EmptyContent message={t("PAGE.NO_OPEN_BETS_ON_EVENT")} />;
		}

		return (
			<div className="event__body event__bets">
				<MyBetsBetsList eventBetsState={eventBetsState} />
				<MyBetsAutosellConfirmation
					store={myBetsViewStore.cashoutStore}
				/>
			</div>
		);
	})();

	return (
		<MyBetsStoreContext.Provider value={myBetsStore}>
			<Modals />
			{content}
		</MyBetsStoreContext.Provider>
	);
});
